(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-discount-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('discount-code-form')) {
  class DiscountCodeForm extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-discount-input]');
      this.applyBtn = this.querySelector('[data-discount-apply]');
      this.errorEl = this.querySelector('[data-discount-error]');

      if (this.applyBtn) this.applyBtn.addEventListener('click', this.onApply);
      if (this.input) this.input.addEventListener('keydown', this.onKeydown);
      this.querySelectorAll('[data-discount-remove]').forEach((btn) => {
        btn.addEventListener('click', this.onRemove);
      });
    }

    onKeydown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onApply();
      }
    };

    onApply = async () => {
      const code = (this.input && this.input.value || '').trim();
      if (!code) return;
      this.clearError();

      const current = this.getAppliedCodes();
      if (current.some((c) => c.toLowerCase() === code.toLowerCase())) {
        if (this.input) this.input.value = '';
        return;
      }

      this.setLoading(true);
      try {
        const next = current.concat(code);
        const state = await this.updateDiscounts(next, true);
        const entry = (state.discount_codes || []).find(
          (c) => c.code && c.code.toLowerCase() === code.toLowerCase()
        );

        if (!entry || entry.applicable === false) {
          // Ungültiger Code: auf vorherigen Stand zurücksetzen, Fehler zeigen, Eingabe behalten.
          await this.updateDiscounts(current, false);
          this.showError();
          this.setLoading(false);
          return;
        }

        this.render(state);
      } catch (err) {
        this.showError();
        this.setLoading(false);
      }
    };

    onRemove = async (event) => {
      const code = event.currentTarget.getAttribute('data-discount-remove');
      const next = this.getAppliedCodes().filter((c) => c.toLowerCase() !== code.toLowerCase());
      this.setLoading(true);
      try {
        const state = await this.updateDiscounts(next, true);
        this.render(state);
      } catch (err) {
        this.setLoading(false);
      }
    };

    getAppliedCodes() {
      return Array.from(this.querySelectorAll('[data-code]')).map((el) => el.getAttribute('data-code'));
    }

    cartElements() {
      return Array.from(document.querySelectorAll('cart-items, cart-drawer-items')).filter(
        (el) => typeof el.getSectionsToRender === 'function' && typeof el.renderContents === 'function'
      );
    }

    sectionsToRender() {
      const set = new Set();
      this.cartElements().forEach((el) => {
        try {
          el.getSectionsToRender().forEach((s) => s.section && set.add(s.section));
        } catch (e) {}
      });
      return Array.from(set);
    }

    async updateDiscounts(codes, withSections) {
      const body = {
        discount: codes.join(','),
        sections_url: window.location.pathname,
      };
      if (withSections) body.sections = this.sectionsToRender();
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      return response.json();
    }

    render(state) {
      this.cartElements().forEach((el) => {
        try {
          el.renderContents(state);
        } catch (e) {}
      });
      this.refreshDiscountForms(state);
      if (window.FoxThemeEvents && typeof window.FoxThemeEvents.emit === 'function') {
        window.FoxThemeEvents.emit('ON_CART_UPDATED', state);
      }
      this.setLoading(false);
    }

    refreshDiscountForms(state) {
      const sections = state.sections || {};
      const freshForms = new Map();

      Object.values(sections).forEach((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('discount-code-form').forEach((form) => {
          const contextClass = Array.from(form.classList).find((className) =>
            className.indexOf('cart-discount-form--') === 0
          );
          if (contextClass && !freshForms.has(contextClass)) {
            freshForms.set(contextClass, form);
          }
        });
      });

      freshForms.forEach((form, contextClass) => {
        document.querySelectorAll(`discount-code-form.${contextClass}`).forEach((currentForm) => {
          currentForm.replaceWith(form.cloneNode(true));
        });
      });
    }

    setLoading(state) {
      this.classList.toggle('is-loading', state);
      if (this.applyBtn) this.applyBtn.disabled = state;
    }

    showError() {
      if (!this.errorEl) return;
      this.errorEl.textContent = this.getAttribute('data-error-text') || '';
      this.errorEl.hidden = false;
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.textContent = '';
      this.errorEl.hidden = true;
    }
  }

  customElements.define('discount-code-form', DiscountCodeForm);
}
  } catch(e) { console.error(e); }
})();

})();
